<template>
	<section style="margin: 30px 0">
		<n-space v-if="store.state.admin.token !== null">
			<n-button type="info"
				@click="state.modal.elem.new.modal_show = true">
				Добавить аксессуар
			</n-button>
			<n-button type="success"
				@click="state.modal.category.list.modal_show = true">
				Категории
			</n-button>
		</n-space>
		<n-space class="wiki-nav"
			style="margin: 20px 0;"  >
			<n-space class="wiki-nav-search">
				<n-input-group style="width: 100%; flex: 1 1 auto">
					<n-input v-model:value="state.search.query"
						:style="{ width: '100%' }"
						class="wiki-nav-search-input"
						placeholder="Введите запрос..."
						round
						@keydown.enter="load(); state.pages.current = 1"/>

					<n-button round
						type="success"
						@click="load(); state.pages.current = 1">
						<n-icon size="20">
							<Search />
						</n-icon>
					</n-button>
				</n-input-group>
				<n-button v-show="state.search.query.length > 0"
					round
					type="error"
					@click="state.search.query = ''; load(); state.pages.current = 1">
					<n-icon size="20">
						<Close />
					</n-icon>
				</n-button>
			</n-space>
			<n-select v-model:value="state.search.type"
				class="wiki-nav-category"
				value-field="id"
				label-field="title"
				clearable
				placeholder="Выберите категорию"
				:options="state.elem_types"/>
		</n-space>
		<n-modal v-model:show="state.modal.elem.new.modal_show" >
			<n-card
				style="max-width: 450px; min-width: 260px"
				title="Добавить аксессуар"
				:bordered="false"
				size="huge"
				role="dialog"
				aria-modal="true"
			>
				<n-form
					:ref="validate.elemNew"
					:rules="state.modal.elem.new.rules"
					:model="state.modal.elem.new"
				>
					<n-form-item label="ID аксессуара"
						path="accessories_id">
						<n-input-number v-model:value="state.modal.elem.new.accessories_id"
							style="width: 100%;"
							:show-button="false"
							placeholder=""/>
					</n-form-item>
					<n-form-item label="Название"
						path="name">
						<n-input v-model:value="state.modal.elem.new.name"
							placeholder="" />
					</n-form-item>
					<n-form-item label="Цена"
						path="price">
						<n-input-number v-model:value="state.modal.elem.new.price"
							style="width: 100%;"
							:show-button="false"
							placeholder=""/>
					</n-form-item>
					<n-form-item label="Цена в донат валюте"
						path="donate_price">
						<n-input-number  v-model:value="state.modal.elem.new.donate_price"
							style="width: 100%;"
							:show-button="false"
							placeholder=""/>
					</n-form-item>
					<n-form-item label="Категория"
						path="elem_types_selection">
						<n-select v-model:value="state.modal.elem.new.type"
							:options="state.elem_types_selection"
							placeholder=""/>
					</n-form-item>
					<n-form-item label="ID инвентаря"
						path="inventory_id">
						<n-input-number v-model:value="state.modal.elem.new.inventory_id"
							style="width: 100%;"
							:show-button="false"
							placeholder=""/>
					</n-form-item>
					<n-form-item label="Изображение">
						<n-upload
							v-model:value="state.modal.elem.new.img"
							directory-dnd
							:max="1"
							list-type="image"
							class="test"
							accept="image/*"
							:action="store.state.backend+'/general/accessories/img'"
							:custom-request="uploadImageNew"

						>
							<n-upload-dragger>
								<n-text>Перетащите изображение сюда или нажмите</n-text>
							</n-upload-dragger>
						</n-upload>
					</n-form-item>
					<n-form-item
						v-if="state.modal.elem.new.img_path !== null"
					>
						<ImageCropper :url="store.state.backend+'/general/accessories/img'"
							img_attr="accessory_img"
							:src="state.modal.elem.new.img_path"
							@save="croppedImageNew"/>
					</n-form-item>
					<n-space justify="space-between">
						<n-button type="info"
							@click="state.modal.elem.new.modal_show = false">Отмена</n-button>
						<n-button type="success"
							@click="createElem">Добавить</n-button>
					</n-space>
				</n-form>
			</n-card>
		</n-modal>
		<n-modal v-model:show="state.modal.category.list.modal_show" >
			<n-card
				style="max-width: 450px; min-width: 260px"
				title="Список категорий"
				:bordered="false"
				size="huge"
				role="dialog"
				aria-modal="true"
			>
				<n-scrollbar style="height: 300px;">
					<n-space vertical
						style="gap: 10px; margin: 20px 0;">
						<n-space v-for="item in state.elem_types"
							:key="item.id"
							align="center"
							justify="space-between"
							style="">
							<span style="font-size: 18px">
								#{{item.id}} - {{ item.title }}
							</span>
							<n-space>
								<n-button  round
									type="success"
									size="small"
									@click="openCategoryEdit(item.id)">
									<template #icon>
										<n-icon >
											<create />
										</n-icon>
									</template>
								</n-button>
								<n-popconfirm negative-text="Отмена"
									positive-text="Удалить!"
									@positive-click="deleteCategory(item.id)">
									<template #trigger>
										<n-button round
											type="error"
											size="small">
											<template #icon>
												<n-icon >
													<trash />
												</n-icon>
											</template>
										</n-button>
									</template>
									Вы уверены?
								</n-popconfirm>
							</n-space>
						</n-space>
					</n-space>
				</n-scrollbar>
				<n-space justify="space-between">
					<n-button type="info"
						@click="state.modal.category.list.modal_show = false">Закрыть</n-button>
					<n-button type="success"
						@click="state.modal.category.new.modal_show = true">Добавить</n-button>
				</n-space>
			</n-card>
		</n-modal>
		<n-modal v-model:show="state.modal.category.new.modal_show" >
			<n-card
				style="max-width: 450px; min-width: 260px"
				title="Добавить категорию"
				:bordered="false"
				size="huge"
				role="dialog"
				aria-modal="true"
			>
				<n-form
					:ref="validate.categoryNew"
					:rules="state.modal.category.new.rules"
					:model="state.modal.category.new"
				>
					<n-form-item label="Название"
						path="title">
						<n-input v-model:value="state.modal.category.new.title"
							placeholder="" />
					</n-form-item>
					<n-space justify="space-between">
						<n-button type="info"
							@click="state.modal.category.new.modal_show = false">Отмена</n-button>
						<n-button type="success"
							@click="createCategory">Добавить</n-button>
					</n-space>
				</n-form>
			</n-card>
		</n-modal>


	</section>

	<h1 class="wiki-h1">Аксессуары</h1>

	<div class="wiki-list">
		<div class="wiki-list-wrapper">
			<div v-for="elem in state.elems"
				:key="elem.id"
				class="wiki-list-item">
				<n-image class="wiki-list-item-img"
					object-fit="cover"
					:src="elem.img"
					width="100"
					height="100"
					fallback-src="/nopic.png"
					:show-toolbar="false" />
				<div class="wiki-list-item-container">
					<div class="wiki-list-item-data">ID: <span>{{ elem.accessories_id }}</span></div>
					<div class="wiki-list-item-data">Название: <span>{{ elem.name }}</span></div>
					<div class="wiki-list-item-data">Категория: <span>{{ getTypeTitle(elem.type) }}</span></div>
					<div class="wiki-list-item-data">ID инвентаря: <span>{{ elem.inventory_id }}</span></div>
					<div class="wiki-list-item-data">Стоимость: <span>{{ elem.price }}</span></div>
					<div class="wiki-list-item-data">Стоимость в донат валюте: <span>{{ elem.donate_price }}</span></div>
				</div>
				<div v-if="store.state.admin.token !== null"
					class="wiki-list-item-edit">
					<n-space>
						<n-button round
							type="info"
							size="small"
							@click="openElemEdit(elem.id)">
							<template #icon>
								<n-icon >
									<create />
								</n-icon>
							</template>
						</n-button>
						<n-popconfirm negative-text="Отмена"
							positive-text="Удалить!"
							@positive-click="deleteElem(elem.id)">
							<template #trigger>
								<n-button round
									type="error"
									size="small">
									<template #icon>
										<n-icon >
											<trash />
										</n-icon>
									</template>
								</n-button>
							</template>
							Вы уверены?
						</n-popconfirm>

					</n-space>
				</div>

			</div>
		</div>

		<n-space justify="center"
			style="margin: 20px 0;" >
			<n-pagination v-show="state.pages.count > 1"
				v-model:page="state.pages.current"
				:page-count="state.pages.count"
				@update="load()" />
		</n-space>
	</div>


	<n-modal v-model:show="state.modal.category.edit.modal_show" >
		<n-card
			style="max-width: 450px; min-width: 260px"
			title="Изменить категорию"
			:bordered="false"
			size="huge"
			role="dialog"
			aria-modal="true"
		>
			<n-form
				:ref="validate.categoryEdit"
				:rules="state.modal.category.edit.rules"
				:model="state.modal.category.edit"
			>
				<n-form-item label="Название"
					path="title">
					<n-input v-model:value="state.modal.category.edit.title"
						placeholder=""/>
				</n-form-item>
				<n-space justify="space-between">
					<n-button type="info"
						@click="state.modal.category.edit.modal_show = false">Отмена</n-button>
					<n-button type="success"
						@click="editCategory">Изменить</n-button>
				</n-space>
			</n-form>
		</n-card>
	</n-modal>
	<n-modal v-model:show="state.modal.elem.edit.modal_show" >
		<n-card
			style="max-width: 450px; min-width: 260px"
			title="Изменить аксессуар"
			:bordered="false"
			size="huge"
			role="dialog"
			aria-modal="true"
		>

			<n-form
				:ref="validate.elemEdit"
				:rules="state.modal.elem.edit.rules"
				:model="state.modal.elem.edit"
			>
				<n-form-item label="ID аксессуара"
					path="accessories_id">
					<n-input-number v-model:value="state.modal.elem.edit.accessories_id"
						style="width: 100%;"
						:show-button="false"
						placeholder=""/>
				</n-form-item>
				<n-form-item label="Название"
					path="name">
					<n-input v-model:value="state.modal.elem.edit.name"
						placeholder="" />
				</n-form-item>
				<n-form-item label="Цена"
					path="price">
					<n-input-number v-model:value="state.modal.elem.edit.price"
						style="width: 100%;"
						:show-button="false"
						placeholder=""/>
				</n-form-item>
				<n-form-item label="Цена в донат валюте"
					path="donate_price">
					<n-input-number  v-model:value="state.modal.elem.edit.donate_price"
						style="width: 100%;"
						:show-button="false"
						placeholder=""/>
				</n-form-item>
				<n-form-item label="Категория"
					path="elem_types_selection">
					<n-select v-model:value="state.modal.elem.edit.type"
						:options="state.elem_types_selection"
						placeholder=""/>
				</n-form-item>
				<n-form-item label="ID инвентаря"
					path="inventory_id">
					<n-input-number v-model:value="state.modal.elem.edit.inventory_id"
						style="width: 100%;"
						:show-button="false"
						placeholder=""/>
				</n-form-item>
				<n-form-item label="Изображение">
					<n-upload
						v-model:value="state.modal.elem.edit.img"
						directory-dnd
						:max="1"
						list-type="image"
						class="test"
						accept="image/*"
						:action="store.state.backend+'/general/accessories/img'"
						:custom-request="uploadImageEdit"

					>
						<n-upload-dragger>
							<n-text>Перетащите изображение сюда или нажмите</n-text>
						</n-upload-dragger>
					</n-upload>
				</n-form-item>
				<n-form-item
					v-if="state.modal.elem.edit.img_path !== null"
				>
					<ImageCropper :url="store.state.backend+'/general/accessories/img'"
						img_attr="accessory_img"
						:src="state.modal.elem.edit.img_path"
						@error="removeImageEdit"
						@save="croppedImageEdit"/>
				</n-form-item>
				<n-space justify="space-between">
					<n-button type="info"
						@click="state.modal.elem.edit.modal_show = false">Отмена</n-button>
					<n-button type="success"
						@click="editElem">Изменить</n-button>
				</n-space>
			</n-form>

		</n-card>
	</n-modal>

</template>

<script setup>

import ImageCropper from "@/extensions/ImageCropper.vue"


import { Create, Trash, Search, Close } from "@vicons/ionicons5"
import { useStore } from "vuex"
import { useMessage } from "naive-ui"
import { useRouter } from "vue-router"

const router = useRouter()
const message = useMessage()
const store = useStore()

import { onMounted, reactive, ref, watch } from "vue"
const validate = {
	elemNew: ref(null),
	elemEdit: ref(null),
	categoryNew: ref(null),
	categoryEdit: ref(null)
}
const state = reactive({
	elems: [],
	search: {
		query: router.currentRoute.value.query.s ?? "",
		type: null
	},
	pages: {
		count: 1,
		current: router.currentRoute.value.query.p ?? 1
	},
	elem_types: [],
	elem_types_selection: [],
	modal: {
		elem: {
			edit: {
				rules: {
					accessories_id: {
						type: "number",
						required: true,
						message: "Введите число",
						trigger: ["input"]
					},
					name: {
						required: true,
						message: "Введите текст",
						trigger: ["input"]
					},
					price: {
						type: "number",
						required: true,
						message: "Введите число",
						trigger: ["input"]
					},
					donate_price: {
						type: "number",
						required: true,
						message: "Введите число",
						trigger: ["input"]
					},
					inventory_id: {
						type: "number",
						required: true,
						message: "Введите число",
						trigger: ["input"]
					}
				},
				id: null,
				accessories_id: null,
				name: null,
				price: null,
				donate_price: null,
				img: null,
				img_path: null,
				type: null,
				inventory_id: null,
			},
			new: {
				rules: {
					accessories_id: {
						type: "number",
						required: true,
						message: "Введите число",
						trigger: ["input"]
					},
					name: {
						required: true,
						message: "Введите текст",
						trigger: ["input"]
					},
					price: {
						type: "number",
						required: true,
						message: "Введите число",
						trigger: ["input"]
					},
					donate_price: {
						type: "number",
						required: true,
						message: "Введите число",
						trigger: ["input"]
					},
					inventory_id: {
						type: "number",
						required: true,
						message: "Введите число",
						trigger: ["input"]
					}
				},
				modal_show: false,
				accessories_id: null,
				name: null,
				price: null,
				donate_price: null,
				img: null,
				img_path: null,
				type: 0,
				inventory_id: null,
			}
		},
		category: {
			list: { modal_show: false },
			edit: {
				modal_show: false,
				id: null,
				title: null,
				rules: {
					title: {
						required: true,
						trigger: [
							"blur", "change"
						],
						message: "Введите текст",
					}
				}
			},
			new: {
				modal_show: false,
				title: null,
				rules: {
					title: {
						required: true,
						trigger: [
							"blur", "change"
						],
						message: "Введите текст",
					}
				}
			}
		}
	}
})

const loadCategory = async() => {
	const response = await fetch(`${store.state.backend}/general/accessories/accessorytype`, {
		method: "POST",
		headers: { "Content-Type": "application/json" }
	})

	if (response.ok) {
		const category = await response.json()
		state.elem_types = category.accessories_types
		state.elem_types_selection = []
		state.elem_types_selection.push({
			label: "N/A",
			value: 0 
		})
		for (let i = 0; i < state.elem_types.length; i++) {
			state.elem_types_selection.push({
				label: state.elem_types[i].title,
				value: state.elem_types[i].id 
			})
		}
	}
}

const load = async() => {
	const response = await fetch(`${store.state.backend}/general/accessories/accessory`, {
		method: "POST",
		headers: { "Content-Type": "application/json" },
		body: JSON.stringify({
			"query": state.search.query,
			"type": state.search.type,
			"page": state.pages.current 
		})
	})
	if (response.ok) {
		const data = await response.json()
		loadCategory()
		state.elems = data.accessories
		state.pages.count = data.pages ?? 1
		state.pages.current = data.current_page
	}
}

const uploadImageNew = async({ file }) => {
	state.modal.elem.new.img_path = window.URL.createObjectURL(file.file)
}

const croppedImageNew = (data) => {
	state.modal.elem.new.img = data.img
	state.modal.elem.new.img_path = data.img_path
}

const uploadImageEdit = async({ file }) => {
	state.modal.elem.edit.img = null
	state.modal.elem.edit.img_path = null
	setTimeout(() => {
		state.modal.elem.edit.img_path = window.URL.createObjectURL(file.file)
	}, 500)
}

const croppedImageEdit = (data) => {
	state.modal.elem.edit.img = data.img
	state.modal.elem.edit.img_path = data.img_path
}

const removeImageEdit = () => {
	state.modal.elem.edit.img_path = null
	state.modal.elem.edit.img = null
}

const createElem = async(e) => {
	e.preventDefault()
	validate.elemNew.value?.validate(async(e) => {
		if (!e) {
			const response = await fetch(`${store.state.backend}/general/accessories/accessory`, {
				method: "PUT",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({
					token: store.state.admin.token,
					inventory_id: state.modal.elem.new.inventory_id,
					type: state.modal.elem.new.type,
					name: state.modal.elem.new.name,
					accessories_id: state.modal.elem.new.accessories_id,
					price: state.modal.elem.new.price,
					donate_price: state.modal.elem.new.donate_price,
					img: state.modal.elem.new.img
				})
			})
			if (response.ok) {
				message.success("Успешно создано!")
				await load()

				state.modal.elem.new.modal_show = false
				state.modal.elem.new.accessories_id = null
				state.modal.elem.new.name = null
				state.modal.elem.new.inventory_id = null
				state.modal.elem.new.price = null
				state.modal.elem.new.donate_price = null
				state.modal.elem.new.img = null
				state.modal.elem.new.img_path = null
				state.modal.elem.new.type = null

			} else {
				const data = await response.json()
				message.error(`Ошибка! ${data.errors}`)

			}
		}
	})

}

const openElemEdit = (id) => {
	state.modal.elem.edit.id = id
	const elem = () => {
		for (let i = 0; i < state.elems.length; i++) {
			let el = state.elems.find(e => e.id === id)
			el = el ?? null
			if (el !== null) {
				return el
			}
		}
	}
	state.modal.elem.edit.type = elem().type
	state.modal.elem.edit.name = elem().name
	state.modal.elem.edit.accessories_id = elem().accessories_id
	state.modal.elem.edit.price = Number(elem().price)
	state.modal.elem.edit.donate_price = Number(elem().donate_price)
	state.modal.elem.edit.img = elem().img
	state.modal.elem.edit.img_path = elem().img
	state.modal.elem.edit.modal_show = true
	state.modal.elem.edit.inventory_id = Number(elem().inventory_id)
}

const editElem = async(e) => {
	e.preventDefault()
	validate.elemEdit.value?.validate(async(e) => {
		if (!e) {
			const response = await fetch(`${store.state.backend}/general/accessories/accessory`, {
				method: "PATCH",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({
					token: store.state.admin.token,
					id: state.modal.elem.edit.id,
					model: state.modal.elem.edit.model,
					type: state.modal.elem.edit.type,
					name: state.modal.elem.edit.name,
					inventory_id: state.modal.elem.edit.inventory_id,
					accessories_id: state.modal.elem.edit.accessories_id,
					price: state.modal.elem.edit.price,
					donate_price: state.modal.elem.edit.donate_price,
					img: state.modal.elem.edit.img
				})
			})
			if (response.ok) {
				state.modal.elem.edit.id = null
				state.modal.elem.edit.model = null
				state.modal.elem.edit.type = null
				state.modal.elem.edit.name = null
				state.modal.elem.edit.inventory_id = null
				state.modal.elem.edit.accessories_id = null
				state.modal.elem.edit.price = null
				state.modal.elem.edit.donate_price = null
				state.modal.elem.edit.img = null
				state.modal.elem.edit.modal_show = false
				message.success("Успешно изменено!")
				await load()
			} else {
				const data = await response.json()
				message.error(`Ошибка! ${data.errors}`)

			}
		}
	})

}

const deleteElem = async(id) => {
	const response = await fetch(`${store.state.backend}/general/accessories/accessory`, {
		method: "DELETE",
		headers: { "Content-Type": "application/json" },
		body: JSON.stringify({
			token: store.state.admin.token,
			id: id,
		})
	})
	if (response.ok) {
		message.success("Успешно удалено!")
		await load()
	} else {
		const data = await response.json()
		message.error(`Ошибка! ${data.errors}`)

	}
}


const createCategory = async(e) => {
	e.preventDefault()
	validate.categoryNew.value?.validate(async(e) => {
		if (!e) {
			const response = await fetch(`${store.state.backend}/general/accessories/accessorytype`, {
				method: "PUT",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({
					token: store.state.admin.token,
					title: state.modal.category.new.title
				})
			})
			if (response.ok) {
				message.success("Успешно создано!")
				await load()

				state.modal.category.new.modal_show = false
				state.modal.category.new.title = null
			} else {
				const data = await response.json()
				message.error(`Ошибка! ${data.errors}`)

			}
		}
	})

}

const openCategoryEdit = (id) => {
	state.modal.category.edit.id = id
	state.modal.category.edit.title = state.elem_types.find(i => i.id === id).title
	state.modal.category.edit.modal_show = true
}

const editCategory = async(e) => {
	e.preventDefault()
	validate.categoryEdit.value?.validate(async(e) => {
		if (!e) {
			const response = await fetch(`${store.state.backend}/general/accessories/accessorytype`, {
				method: "PATCH",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({
					token: store.state.admin.token,
					id: state.modal.category.edit.id,
					title: state.modal.category.edit.title
				})
			})
			if (response.ok) {
				message.success("Успешно изменено!")
				await load()
			} else {
				const data = await response.json()
				message.error(`Ошибка! ${data.errors}`)

			}
		}
	})

}

const deleteCategory = async(id) => {
	const response = await fetch(`${store.state.backend}/general/accessories/accessorytype`, {
		method: "DELETE",
		headers: { "Content-Type": "application/json" },
		body: JSON.stringify({
			token: store.state.admin.token,
			id: id,
		})
	})
	if (response.ok) {
		message.success("Успешно удалено!")
		await load()
	} else {
		const data = await response.json()
		message.error(`Ошибка! ${data.errors}`)

	}
}

const getTypeTitle = (id) => {
	try {
		return state.elem_types.find(i => i.id === id).title
	} catch {
		return "N/A"
	}
}

watch(
	() => state.pages.current,
	(curr) => {
		router.push({
			path: router.currentRoute.value.fullPath,
			query: {
				p: curr,
				s: state.search.query 
			}
		})
		load()
	}
)
watch(
	() => state.search.type,
	() => {
		load()
	}
)
watch(
	() => state.search.query,
	(curr) => {
		router.push({
			path: router.currentRoute.value.fullPath,
			query: {
				p: state.pages.current,
				s: curr 
			}
		})
	}
)

onMounted(() => {
	load()
})
</script>

<style>

</style>